<template>
  <div class="body bodys">
    <div  class="login-top">
     <!-- <div id="w-center" >
        <a href="/">
          <img :src="info.logo" alt="">
        </a>
        <p>登录</p>
      </div> -->
    </div>
    <div class="login-center">
<!--       <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true class="long-c">
          <el-tab-pane name="first" class="login-text">

          </el-tab-pane>
        </el-tabs> -->

        <!-- <img :src="info.logo" alt=""> -->
         <Ptmember @setPtzc="ptzc = 1"></Ptmember>

    </div>
    <div class="h-40"></div>
    <div class="login-botm">{{info.foot}}</div>
  </div>
</template>
<style scoped>
    body{background: #f5f7fa;}
    .login-center >>> .el-tabs__item {font-size: 22px;font-weight: bold;}
    .login-center >>> .el-tabs__active-bar{width: 0px !important;left: 47%;background-color: #2c5fab}
    .login-center >>> .el-tabs__item:hover{color: #2c5fab;}
    .login-center >>> .el-tabs__item.is-active{color: #2c5fab;}
    .login-center >>> .el-tabs__nav-wrap::after{background-color:#f5f7fa !important;}
    .login-center >>> .el-tabs__nav-wrap::after{background-color:#f5f7fa !important;}
</style>
<script>

import ptmember from '@/components/login/ptmember.vue'
import ptzc from '@/components/login/ptzc.vue'
export default{
  data(){
    return {
      info:[],
      activeName: 'first',
      ptzc:'',
    }
  },
  components: {
    'Ptmember': ptmember,  //将别名demo 变成 组件 Demo
    'Ptzc': ptzc
  },
  mounted () {
    console.log(123)
    this.ptzc = this.$route.query.ptzc;
    // console.log(this.ptzc);
    this.recordapi();
  },
  methods:{
    recordapi(){

        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Login/Loginshow",{'userid':userid}).then(res => {
           console.log(123);
          console.log(res);
          that.info= res;
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue